import React from 'react'

import { Button } from '@wartek-id/button-v1'
import { useToast } from '@wartek-id/toast-v2'

import useToggleSdkContext from 'utils/useToogleSdk'
import { useApiResetSkp } from 'api/kinerja/pengawas-sekolah/perencanaan'
import { capitalizeFirstLetter } from 'utils/text'
import { useAuth } from 'utils/auth'

import type { FC } from 'react'
import type { TResetSKPPhase } from 'types/kinerja-ps-pegawai'

type ButtonsResetProps = {}

const RESET_PHASE_ARRAY: TResetSKPPhase[] = ['PERENCANAAN', 'PELAKSANAAN']

const ButtonsReset: FC<ButtonsResetProps> = ({}) => {
  const toast = useToast()
  const toggle = useToggleSdkContext()
  const { session } = useAuth()

  const toggleEnabled = toggle?.['kinerja-ps-pegawai-reset-enabled'] || false
  const isAccountWhitelisted = Boolean(
    typeof session?.user?.email === 'string' &&
      /@testing\.belajar\.id$/i.test(session?.user?.email)
  )
  const resetable = toggleEnabled || isAccountWhitelisted

  const [resetSKPPhase, setResetSKPPhase] = React.useState<
    TResetSKPPhase | undefined
  >(undefined)

  const { mutateAsync: resetSkp, isLoading: isMutating } = useApiResetSkp({
    phase: resetSKPPhase,
  })

  const handleReset = React.useCallback(async () => {
    try {
      if (
        confirm(
          `Apakah Anda yakin ingin mereset data ${capitalizeFirstLetter(
            resetSKPPhase.toLowerCase()
          )} SKP?`
        )
      ) {
        await resetSkp({})
        toast({
          message: `Berhasil mereset data ${capitalizeFirstLetter(
            resetSKPPhase.toLowerCase()
          )} SKP`,
          type: 'success',
        })

        setTimeout(() => {
          window.location.reload()
        }, 4000)
      }
    } catch (error) {
      toast({
        message: 'Gagal mereset data SKP',
      })
    } finally {
      setResetSKPPhase(undefined)
    }
  }, [resetSKPPhase, resetSkp, toast])

  React.useEffect(() => {
    if (Boolean(resetSKPPhase)) {
      handleReset()
    }

    return () => {
      setResetSKPPhase(undefined)
    }
  }, [handleReset, resetSKPPhase])

  // If not resetable, return null instead so it won't render the button at all
  if (!resetable) return null

  return (
    <div className="fixed right-0 z-50 flex gap-2 p-4 bottom-10">
      {RESET_PHASE_ARRAY.map((phase, index) => (
        <Button
          key={index}
          size="sm"
          disabled={isMutating}
          variant="solid"
          color="red"
          onClick={() => {
            setResetSKPPhase(phase)
          }}
        >
          Reset {capitalizeFirstLetter(phase.toLowerCase())}
        </Button>
      ))}
    </div>
  )
}
export default ButtonsReset
